import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Market } from '../../models/market.model';
import { SubSink } from 'subsink';
import { MarketService } from '../../service/market.service';

@Component({
  selector: 'app-market-selector',
  templateUrl: './market-selector.component.html',
  styleUrls: ['./market-selector.component.scss']
})
export class MarketSelectorComponent implements OnInit, OnDestroy {
  private sub = new SubSink();
  @ViewChild('autoInput') input!: ElementRef;
  filteredMarkets!: Market[];
  markets!: Market[];
  selectedMarket!: Market;
  @Output() selectedMarketChange = new EventEmitter<Market>();

  constructor(private marketService: MarketService) {
  }

  onChange(): void {
    this.filteredMarkets = this.getFilteredOptions(this.input.nativeElement.value);
  }

  getFilteredOptions(value: string): Market[] {
    value = value ?? '';
    return this.markets.filter(
      (market) =>
        market.baseCurrency.id.toLowerCase().search(value.toLowerCase()) !== -1 ||
        market.quoteCurrency.id.toLowerCase().search(value.toLowerCase()) !== -1 ||
        market.quoteCurrency.name.search(value) !== -1 ||
        market.baseCurrency.name.search(value) !== -1
    );
  }


  onSelectionChange(query: Market): void {
    this.input.nativeElement.value = query.baseCurrency.name + ' - ' + query.quoteCurrency.name;
    this.selectedMarket = query;
    this.selectedMarketChange.emit(this.selectedMarket);
  }


  ngOnInit(): void {
    this.sub.sink = this.marketService.getMarkets().subscribe((markets) => {
      this.markets = markets;
      this.selectedMarket = markets[0];
      this.filteredMarkets = this.markets;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
